import { createSelector } from 'reselect'
import { Currencies } from '@payu/paymentsos-types'

import { State } from './reducer'

export interface Store {
  Currencies: State
}

export const getCurrencies = (state: Store): Currencies.Currency[] => state.Currencies.currencies

interface MapType {
  [x: string]: string
}

export const getCurrencyCodeToCountryNameMap = createSelector(getCurrencies,
  countries => countries.reduce(
    (acc, currency): MapType => { acc[currency.code] = currency.name; return acc }, {}
  ))

export const getCurrencyNameToCountryCodeMap = createSelector(getCurrencies,
  countries => countries.reduce(
    (acc, currency): MapType => { acc[currency.name] = currency.code; return acc }, {}
  ))
